export const parseCurrencyToNumber = (value: string): number | null => {
  if (!value || value === '.') return null
  const cleanValue = value.replace(/[^0-9.]/g, '')
  const parsed = parseFloat(cleanValue)
  return isNaN(parsed) ? null : parsed
}

export const formatCurrency = (value: number | null | undefined): string => {
  if (value === null || value === undefined) return ''
  return value.toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })
}
